// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nh5[data-v-435fe576] {\n  color: var(--sea);\n  font-size: 1.4rem;\n  font-weight: 400 !important;\n}\n.trending-icon[data-v-435fe576] {\n  width: 25px;\n}\n", ""]);
// Exports
module.exports = exports;
